import { ViewPlugin, Decoration, DecorationSet, EditorView, ViewUpdate } from "@codemirror/view";
import { Extension, RangeSetBuilder } from "@codemirror/state";

const TFID_REGEX = /\b[0-9a-z]{13}\b/g;

const tfidMark = Decoration.mark({ class: "cm-tfid" });

const tfidViewPlugin = ViewPlugin.fromClass(
  class {
    decorations: DecorationSet;

    constructor(view: EditorView) {
      this.decorations = this.buildDecorations(view);
    }

    update(update: ViewUpdate) {
      if (update.docChanged || update.viewportChanged) {
        this.decorations = this.buildDecorations(update.view);
      }
    }

    buildDecorations(view: EditorView): DecorationSet {
      const builder = new RangeSetBuilder<Decoration>();

      for (const { from, to } of view.visibleRanges) {
        const text = view.state.doc.sliceString(from, to);
        let match: RegExpExecArray | null;
        TFID_REGEX.lastIndex = 0;

        while ((match = TFID_REGEX.exec(text)) !== null) {
          const start = from + match.index;
          const end = start + 13;
          builder.add(start, end, tfidMark);
        }
      }

      return builder.finish();
    }
  },
  {
    decorations: (v) => v.decorations,
  },
);

const tfidBaseTheme = EditorView.baseTheme({
  ".cm-tfid": {
    backgroundColor: "rgba(255, 213, 79, 0.30)",
    borderBottom: "1.5px dotted #f57c00",
    borderRadius: "2px",
    cursor: "default",
  },
});

export const tfidHighlightExtension: Extension = [tfidViewPlugin, tfidBaseTheme];
